<dx-popup
    title="Job"
    [width]="'min(600px, 95vw)'"
    [height]="'auto'"
    [maxHeight]="'95vh'"
    [(visible)]="visible"
    [hideOnOutsideClick]="false"
    (onHiding)="onHiding($event)"
>
    <dxi-popup-toolbar-item widget="dxButton" location="after" [options]="{ text: 'Audit Log', type: 'default', onClick: openAuditLog }">
    </dxi-popup-toolbar-item>
    <dxi-popup-toolbar-item widget="dxButton" location="after" [options]="{ text: 'Save', type: 'success', onClick: save }">
    </dxi-popup-toolbar-item>
    <dxi-popup-toolbar-item widget="dxButton" location="after" [options]="{ text: 'Cancel', type: 'danger', onClick: cancel }">
    </dxi-popup-toolbar-item>
    <dx-scroll-view>
        @if (job) {
            <dx-form [formData]="job" validationGroup="mainValidationGroup">
                @if (job.rentalId) {
                    <dxi-form-item dataField="rental.customer.displayName" [label]="{ text: 'Customer' }" [disabled]="true">
                    </dxi-form-item>
                }
                <dxi-form-item dataField="displayId" [label]="{ text: 'Id' }" [disabled]="true"> </dxi-form-item>
                <dxi-form-item itemType="group" [colCount]="2">
                    <dxi-form-item [label]="{ text: 'Dumpster' }">
                        <div *dxTemplate>
                            <dx-select-box
                                [(value)]="job.dumpsterId"
                                [items]="dumpsters"
                                valueExpr="id"
                                displayExpr="size"
                                [width]="'250px'"
                                [disabled]="!canChangeDumpster"
                                (onValueChanged)="dumpsterChanged($event)"
                            ></dx-select-box>
                        </div>
                    </dxi-form-item>
                    <dxi-form-item [label]="{ text: 'Bill As' }">
                        <div *dxTemplate>
                            <dx-select-box
                                [(value)]="job.billAsDumpsterId"
                                [items]="dumpsters"
                                valueExpr="id"
                                displayExpr="size"
                                [width]="'250px'"
                                [disabled]="!isDifferentThanRental"
                                (onValueChanged)="billAsDumpsterChanged($event)"
                            ></dx-select-box>
                        </div>
                        <dxi-form-validation-rule type="required" message="Required"> </dxi-form-validation-rule>
                    </dxi-form-item>
                </dxi-form-item>
                <dxi-form-item dataField="jobType.name" [label]="{ text: 'Type' }" [disabled]="true"> </dxi-form-item>
                <dxi-form-item [label]="{ text: 'Address' }">
                    <div *dxTemplate class="d-flex">
                        <dx-text-box [value]="job.displayAddress" class="flex-fill" [disabled]="true"></dx-text-box>
                        @if (job.rental && job.rental.serviceAddressId) {
                            <button class="btn btn-primary mx-3" (click)="openServiceAddress(job.rental.serviceAddressId)">Edit</button>
                        }
                    </div>
                </dxi-form-item>
                <dxi-form-item itemType="group" [colCount]="2">
                    <dxi-form-item
                        dataField="weight"
                        [editorOptions]="{ width: '250px' }"
                        [disabled]="job.completed && !completeJobMode && !isAdmin"
                    >
                        @if (job.completed && !completeJobMode) {
                            <dxi-form-validation-rule type="required" message="Required"> </dxi-form-validation-rule>
                        }
                        <dxi-form-validation-rule type="range" [min]="0" message="Weight must be at least 0"> </dxi-form-validation-rule>
                    </dxi-form-item>
                    @if (completeJobMode) {
                        <dxi-form-item [label]="{ text: '' }">
                            <div *dxTemplate class="d-flex">
                                <button class="btn btn-sm btn-danger mx-3 mt-2" (click)="completeJob()">Complete Job</button>
                            </div>
                        </dxi-form-item>
                    }
                </dxi-form-item>
                @if (!completeJobMode) {
                    <dxi-form-item
                        dataField="inventory.dumpsterBarcode"
                        [label]="{ text: 'Barcode' }"
                        [editorOptions]="{ width: '250px' }"
                        [disabled]="true"
                    >
                    </dxi-form-item>
                }
                @if (!completeJobMode && changeableInventories) {
                    <dxi-form-item [label]="{ text: 'Change Dumpster' }">
                        <div *dxTemplate class="d-flex align-items-center">
                            <dx-select-box
                                [(value)]="changeInventoryId"
                                [items]="changeableInventories"
                                valueExpr="id"
                                displayExpr="dumpsterBarcode"
                                [searchEnabled]="true"
                                [width]="'250px'"
                            ></dx-select-box>
                            <button class="btn btn-sm btn-warning ms-2" [disabled]="!changeInventoryId" (click)="changeDumpster()">Change</button>
                        </div>
                    </dxi-form-item>
                }
                @if (canSetDumpSite) {
                    <dxi-form-item [label]="{ text: 'Dump Location' }">
                        <div *dxTemplate>
                            <dx-select-box
                                [(value)]="job.dumpSiteId"
                                [items]="dumpSites"
                                valueExpr="id"
                                displayExpr="name"
                                [width]="'250px'"
                                [disabled]="!completeJobMode"
                            ></dx-select-box>
                        </div>
                    </dxi-form-item>
                }
                @if (completeJobMode && inventories) {
                    <dxi-form-item [label]="{ text: 'Use Dumpster' }">
                        <div *dxTemplate>
                            <dx-select-box
                                [(value)]="inventoryId"
                                [items]="inventories"
                                valueExpr="id"
                                displayExpr="dumpsterBarcode"
                                [width]="'250px'"
                            ></dx-select-box>
                        </div>
                    </dxi-form-item>
                }
                <dxi-form-item itemType="group" [colCount]="2">
                    @if (completeJobMode && isStorageDestination) {
                        <dxi-form-item [label]="{ text: 'Pick Dumpster' }">
                            <div *dxTemplate>
                                <dx-select-box
                                    [(value)]="destinationPickId"
                                    [items]="storagePickInventories"
                                    valueExpr="id"
                                    displayExpr="dumpsterBarcode"
                                    [width]="'250px'"
                                ></dx-select-box>
                            </div>
                        </dxi-form-item>
                    }
                    @if (completeJobMode && isStorageDestination) {
                        <dxi-form-item [label]="{ text: 'Drop Dumpster' }">
                            <div *dxTemplate>
                                <dx-select-box
                                    [(value)]="destinationDropId"
                                    [items]="storageDropInventories"
                                    valueExpr="id"
                                    displayExpr="dumpsterBarcode"
                                    [width]="'250px'"
                                ></dx-select-box>
                            </div>
                        </dxi-form-item>
                    }
                </dxi-form-item>
                <dxi-form-item itemType="group" [colCount]="2">
                    <dxi-form-item dataField="startDate" editorType="dxDateBox" [editorOptions]="{ type: 'date', width: '150px' }">
                    </dxi-form-item>
                    <dxi-form-item
                        dataField="preferredStartTime"
                        editorType="dxDateBox"
                        [label]="{ text: 'Preferred Start' }"
                        [editorOptions]="{ type: 'time', pickerType: 'list', width: '150px', onValueChanged: startTimeValueChanged }"
                    ></dxi-form-item>
                    <dxi-form-item dataField="endDate" editorType="dxDateBox" [editorOptions]="{ type: 'date', width: '150px' }">
                    </dxi-form-item>
                    <dxi-form-item
                        dataField="preferredEndTime"
                        editorType="dxDateBox"
                        [label]="{ text: 'Preferred End' }"
                        [editorOptions]="{ type: 'time', pickerType: 'list', width: '150px', onValueChanged: endTimeValueChanged }"
                    ></dxi-form-item>
                </dxi-form-item>
                <dxi-form-item
                    dataField="notes"
                    editorType="dxTextArea"
                    [label]="{ text: 'Site Notes' }"
                    [editorOptions]="{ height: '100px' }"
                >
                </dxi-form-item>
                <dxi-form-item dataField="driverNotes" editorType="dxTextArea" [editorOptions]="{ height: '100px' }"> </dxi-form-item>
                <dxi-form-item
                    dataField="extraExpense"
                    editorType="dxCheckBox"
                    [label]="{ text: 'Additional Expense Due to Inventory Issue' }"
                ></dxi-form-item>
                @if (canEditJobTimes) {
                    <dxi-form-item>
                        <div *dxTemplate class="d-flex">
                            <button class="btn btn-sm btn-primary mt-2" (click)="openJobTimeDialog()">Edit Job Times</button>
                        </div>
                    </dxi-form-item>
                }
                <dxi-form-item itemType="group" [colCount]="3">
                    <dxi-form-item
                        dataField="started"
                        editorType="dxDateBox"
                        [editorOptions]="{ type: 'datetime', width: '150px' }"
                        [disabled]="true"
                    >
                    </dxi-form-item>
                    <dxi-form-item
                        dataField="completed"
                        editorType="dxDateBox"
                        [editorOptions]="{ type: 'datetime', width: '150px' }"
                        [disabled]="true"
                    >
                    </dxi-form-item>
                    <dxi-form-item dataField="fuelRatePercentage.rate" [label]="{ text: 'Fuel Rate Percentage' }" [disabled]="true">
                    </dxi-form-item>
                </dxi-form-item>
                <dxi-form-item itemType="group" [colCount]="3">
                    <dxi-form-item [label]="{ text: 'Latest Dumpster' }">
                        <div *dxTemplate>
                            <dx-text-box [value]="latestDumpsterInfo.barcode" width="150" [disabled]="true"></dx-text-box>
                        </div>
                    </dxi-form-item>
                    <dxi-form-item [label]="{ text: 'By User' }">
                        <div *dxTemplate>
                            <dx-text-box [value]="latestDumpsterInfo.byUser" width="150" [disabled]="true"></dx-text-box>
                        </div>
                    </dxi-form-item>
                    <dxi-form-item [label]="{ text: 'Date' }">
                        <div *dxTemplate>
                            <dx-text-box [value]="latestDumpsterInfo.date" width="150" [disabled]="true"></dx-text-box>
                        </div>
                    </dxi-form-item>
                    @if (dumpsterLocations && dumpsterLocations.length > 0) {
                        <dxi-form-item>
                            <div id="additional-dumpsters" *dxTemplate class="mt-3">
                                <div>Additional Dumpsters</div>
                                <dx-context-menu [dataSource]="dumpsterLocations" [width]="250" target="#additional-dumpsters">
                                </dx-context-menu>
                            </div>
                        </dxi-form-item>
                    }
                </dxi-form-item>
                <dxi-form-item itemType="group" [colCount]="3">
                    <dxi-form-item dataField="distanceFromPreviousJob" [label]="{ text: 'Distance' }" [editorOptions]="{ width: '150px' }">
                    </dxi-form-item>
                    <dxi-form-item
                        dataField="timeFromPreviousJobRoute"
                        [label]="{ text: 'Time/Radar' }"
                        [editorOptions]="{ width: '150px' }"
                    >
                    </dxi-form-item>
                    <dxi-form-item
                        dataField="timeFromPreviousJobDriverCompleted"
                        [label]="{ text: 'Time/JobCompleted' }"
                        [editorOptions]="{ width: '150px' }"
                    >
                    </dxi-form-item>
                </dxi-form-item>
            </dx-form>
        }
    </dx-scroll-view>
</dx-popup>
